// import React, { useEffect } from "react";
// import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
// import { Link, useParams } from "react-router-dom";
// import MainLayout from "../../Layout/mainLayout";
// import { useSelector } from "react-redux";
// import "./viewCoupon.css";
// import { ReactComponent as Usages } from "./Icons/Usages.svg";
// import { icons } from "../../icons";
// import { DateToLocale, ToFirstCapital } from "../../Utils/helpers";
// import H2Element from "../../Global Functions/h2Element";

// const ViewCoupons = () => {
//   const { id } = useParams();

//   const { coupons } = useSelector((state) => state.coupons);

//   const foundCoupon = coupons?.data?.find((coupon) => coupon._id === id);

//   useEffect(() => {
//     console.log("Coupons data from backend:", coupons);
//   }, [coupons]);

//   return (
//     <MainLayout>
//       <div className="row-span-8 grid-span-5 margin-h-10">
//         <div className="flex-container align-center gap-5">
//           <Link to="/dealsAndOffers">
//             <BackIcon style={{ cursor: "pointer" }} />
//           </Link>
//           <div>
//             <h3 className="margin-h-10">{foundCoupon?.code || "No Data Found"}</h3>
//             <h4 className="margin-h-10">Coupon/ List/ View</h4>
//           </div>
//         </div>
//         <div
//           style={{
//             background: "#181E2E",
//           }}
//           className="border-24 padding-20 margin-h-10"
//         >
//           <div
//             style={{
//               background: " rgba(255, 255, 255, 0.16)",
//               boxShadow: "0px 4px 8px 0px rgba(27, 27, 27, 0.16)",
//               backdropFilter: "blur(8px)",
//             }}
//             className="padding-20 border-24"
//           >
//             <div className="flex-container flex-justify-between align-center">
//               <div
//                 style={{
//                   backgroundImage: `url("https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750938688867_image_Background.svg")`,
//                   backgroundSize: "cover",
//                   border: "none",
//                   backgroundPosition: "center",
//                   width: "180px",
//                   height: "180px",
//                 }}
//                 className="padding-20"
//               >
//                 <h2 className="font-white">
//                   {foundCoupon?.project?.project_name || "No Data"}
//                 </h2>
//                 <h3 className="font-white">
//                   {foundCoupon?.value} {foundCoupon?.discount_type}
//                 </h3>
//               </div>

//               <H2Element label="Coupon Code" bgBlue value={foundCoupon?.code}></H2Element>
//               <hr className="coupon_hr" />

//               <H2Element
//                 label="Coupon Value"
//                 bgBlue
//                 value={foundCoupon?.value + " " + foundCoupon?.discount_type}
//               ></H2Element>
//               <hr className="coupon_hr" />
//               <H2Element
//                 label="Project Name"
//                 bgBlue
//                 value={foundCoupon?.project?.project_name || "No Data"}
//               ></H2Element>
//               <div style={{ width: "20px" }}></div>
//             </div>
//             <div className="flex-container flex-justify-between margin-h-10">
//               <div className="flex-container gap-10">
//                 <img src={icons["Date"]} alt="" />
//                 <div>
//                   <span className="span-class-coupon">Valid From</span>
//                   <p className="font-white margin-0">{DateToLocale(foundCoupon?.created_at)}</p>
//                 </div>
//               </div>
//               <div className="flex-container gap-10">
//                 <img src={icons["Date"]} alt="" />
//                 <div>
//                   <span className="span-class-coupon">Valid Till</span>
//                   <p className="font-white margin-0">{DateToLocale(foundCoupon?.end_date)}</p>
//                 </div>
//               </div>
//               <div className="flex-container gap-10">
//                 <Usages></Usages>
//                 <div>
//                   <span className="span-class-coupon">No. of Usages</span>
//                   <p className="font-white margin-0">{foundCoupon?.no_of_usage || 0}</p>
//                 </div>
//               </div>
//               <div className="flex-container gap-10">
//                 <img src={icons["Status"]} alt="" />
//                 <div>
//                   <span className="span-class-coupon">Status</span>
//                   <p className="font-white margin-0">{ToFirstCapital(foundCoupon?.status)}</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </MainLayout>
//   );
// };

// export default ViewCoupons;

import React, { useEffect, useState } from "react";
import "../Manage Projects/viewProjects.css";
import SearchBar from "../Main/searchBar";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { DateToLocale, ToFirstCapital } from "../../Utils/helpers";
import "./viewCoupon.css";
import { icons } from "../../icons";
import toast from "react-hot-toast";
import { viewCoupon } from "../../Redux/Actions/couponsAction"; // update the path if necessary

const ViewCoupons = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [foundCoupon, setFoundCoupon] = useState(null);
  const [loading, setLoading] = useState(false);

  const couponViewState = useSelector((state) => state.coupons); // adjust slice name if different

  useEffect(() => {
    setLoading(true);
    dispatch(viewCoupon(id))
      .then((res) => {
        if (res && res.statusCode === 200) {
          setFoundCoupon(res.data);
        } else {
          toast.error(res?.message || "Failed to load coupon");
        }
      })
      .catch(() => {
        toast.error("Error fetching coupon details");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch, id]);

  if (loading) {
    return (
      <div className="padding-20" style={{ color: "white" }}>
        Loading coupon data ...
      </div>
    );
  }

  if (!foundCoupon) {
    return (
      <div className="padding-20" style={{ color: "white" }}>
        No Coupon Data Found.
      </div>
    );
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)",
        gridAutoRows: "minmax(60px, auto)",
      }}
      className="padding-20 gap-10 grid-container"
    >
      <div style={{ gridColumn: "2/8" }}>
        <SearchBar style={{ width: "max-content" }} />
      </div>

      <div
        className="back-icon margin-0 gap-10 align-center flex-container"
        style={{ gridColumn: "span 7" }}
      >
        <Link to="/dealsAndOffers">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div>
          <h3>{foundCoupon?.code || "No Data"}</h3>
          <h4 style={{ position: "relative", top: "-10px" }}>
            Coupon / List / View
          </h4>
        </div>
      </div>

      <div className="overall-container" style={{ gridColumn: "span 7" }}>
        <div
          style={{ backgroundColor: " rgba(255, 255, 255, 0.16)" }}
          className="flex-container flex-justify-between border-24 align-center padding-20"
        >
          {/* Project Info */}
          <div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                Project Name
              </span>
              <h2 className="h2-column" style={{ color: "white" }}>
                {foundCoupon?.project?.project_name || "No Data"}
              </h2>
            </div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                Builder Name
              </span>
              <h2 className="h2-column" style={{ color: "white" }}>
                {foundCoupon?.builder?.brand_name || "No Data"}
              </h2>
            </div>
          </div>
          <hr className="project_hr" />

          {/* Conditional Discount Type - only show if discounts array is empty */}
          {(!foundCoupon?.discounts || foundCoupon.discounts.length === 0) && (
            <>
              <div className="flex-container flex-column">
                <span className="span-column" style={{ color: "#999" }}>
                  Discount Type
                </span>
                <h2 className="h2-column">
                  {foundCoupon?.discount_type
                    ? `${ToFirstCapital(foundCoupon.discount_type)} (${
                        foundCoupon.discount_in === "percent"
                          ? foundCoupon.value + "%"
                          : "₹" + foundCoupon.value
                      }${
                        foundCoupon.value_upto_show > 0
                          ? ` upto ₹${foundCoupon.value_upto_show}`
                          : ""
                      })`
                    : "No Data"}
                </h2>
              </div>
              <hr className="project_hr" />
            </>
          )}
          {foundCoupon?.discounts && foundCoupon.discounts.length > 0 && (
            <>
              <div>
                <div className="flex-container flex-column">
                  <span className="span-column" style={{ color: "#999" }}>
                    Discounts
                  </span>
                  <div className="h2-column" style={{ color: "white" }}>
                    <ul style={{ margin: 0, paddingLeft: "16px" }}>
                      {foundCoupon.discounts.map((disc) => (
                        <li key={disc._id} style={{ marginBottom: "4px" }}>
                          {disc.unit} : {disc.discount_type}{" "}
                          {disc.discount_in === "percent"
                            ? disc.value + "%"
                            : "₹" + disc.value}{" "}
                          {disc.value_upto_show > 0
                            ? `(Upto ₹${disc.value_upto_show})`
                            : ""}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <span className="span-column" style={{ color: "#999" }}>
                  Max Value
                </span>
                <div className="h2-column" style={{ color: "white" }}>
                  <ul style={{ margin: 0, paddingLeft: "16px" }}>
                    {foundCoupon.discounts.map((disc) => (
                       disc.max_value
                    ))}
                  </ul>
                </div>
                </div>
              </div>
              <hr className="project_hr" />
            </>
          )}

          {/* Status and Usage */}
          <div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                No. of Usages
              </span>
              <h2 className="h2-column">{foundCoupon?.no_of_usage || 0}</h2>
            </div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                Status
              </span>
              <h2 className="h2-column">
                {ToFirstCapital(foundCoupon?.status)}
              </h2>
            </div>
          </div>
          <hr className="project_hr" />

          {/* Dates */}
          <div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                Valid From
              </span>
              <h2 className="h2-column" style={{ color: "white" }}>
                {DateToLocale(foundCoupon?.start_date)}
              </h2>
            </div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                Valid Till
              </span>
              <h2 className="h2-column">
                {DateToLocale(foundCoupon?.end_date)}
              </h2>
            </div>
          </div>
        </div>

        {/* Catalogue + Project Category in same row */}
        <div
          className="flex-container "
          style={{ marginTop: "10px", gap: "300px" }}
        >
          <div className="flex-container flex-column">
            <span className="span-column" style={{ color: "#999" }}>
              Catalogue
            </span>
            <h2 className="h2-column" style={{ color: "white" }}>
              {foundCoupon?.catalogue?.tower_name || "No Data"}
            </h2>
          </div>

          <div className="flex-container flex-column">
            <span className="span-column" style={{ color: "#999" }}>
              Project Category
            </span>
            <h2 className="h2-column" style={{ color: "white" }}>
              {foundCoupon?.project_categories?.[0]?.name || "No Data"}
            </h2>
          </div>
        </div>

        {/* Description row (below Catalogue + Project Category) */}
        {/* Description + Primary Status */}
        <div
          className="flex-container flex-column"
          style={{ marginTop: "10px" }}
        >
          {/* Description */}
          <span className="span-column" style={{ color: "#999" }}>
            Description
          </span>
          <h2
            className="h2-column"
            style={{ color: "white", marginBottom: "10px" }}
          >
            {foundCoupon?.description || "No Description Available"}
          </h2>

          {/* Primary Status */}
          <span className="span-column" style={{ color: "#999" }}>
            Primary Status
          </span>
          <h2 className="h2-column" style={{ color: "white" }}>
            {foundCoupon?.set_primary === true ? "Primary" : "Not-primary"}
          </h2>
        </div>

        {/* Units Info */}
        <h2
          style={{
            color: "white",
            margin: "20px 0 10px 10px",
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          Units Information
        </h2>
        <div
          className="flex-container flex-wrap"
          style={{
            gap: "15px",
            paddingLeft: "10px",
          }}
        >
          {foundCoupon?.unitno && foundCoupon.unitno.length > 0 ? (
            foundCoupon.unitno.map((unit) => (
              <div
                key={unit.catalogue_unit_id}
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.16)",
                  borderRadius: "12px",
                  padding: "10px",
                  width: "160px",
                  color: "white",
                }}
              >
                <div>
                  <strong>Unit No:</strong> {unit.unitno}
                </div>
                <div>
                  <strong>Floor:</strong> {unit.floor}
                </div>
                <div>
                  <strong>Furnishing:</strong> {unit.furnishingstatus || "N/A"}
                </div>
              </div>
            ))
          ) : (
            <div style={{ color: "white", paddingLeft: "10px" }}>
              No Unit Information Available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewCoupons;
